<template>
  <ul class="e-menu">
    <slot></slot>
  </ul>
</template>

<script>
	export default {
		name: "e-menu",
    methods: {
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/sidebar/menu.vue